'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require('lodash');

var _reactResponsiveModal = require('react-responsive-modal');

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

require('react-select/dist/react-select.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInputAddNew = function (_React$PureComponent) {
  _inherits(SelectInputAddNew, _React$PureComponent);

  function SelectInputAddNew(props) {
    _classCallCheck(this, SelectInputAddNew);

    var _this = _possibleConstructorReturn(this, (SelectInputAddNew.__proto__ || Object.getPrototypeOf(SelectInputAddNew)).call(this, props));

    _this.state = {
      formInput: {},
      showForm: false
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleFormChange = _this.handleFormChange.bind(_this);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
    _this.handleAddNewClick = _this.handleAddNewClick.bind(_this);
    _this.handleModalClose = _this.handleModalClose.bind(_this);
    _this.generateAddNewOption = _this.generateAddNewOption.bind(_this);
    _this.updateOptions = _this.updateOptions.bind(_this);
    return _this;
  }

  _createClass(SelectInputAddNew, [{
    key: 'handleFormChange',
    value: function handleFormChange(formInput) {
      this.setState({ formInput: formInput });
      this.props.onFormChange(formInput);
    }
  }, {
    key: 'handleFormSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(formInput) {
        var _props, id, onChange, onBlur, onFormSubmit, submittedValue;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, id = _props.id, onChange = _props.onChange, onBlur = _props.onBlur, onFormSubmit = _props.onFormSubmit;
                // Let the onSubmit handler manipulate/derive a value from the form data.

                _context.next = 3;
                return onFormSubmit(formInput);

              case 3:
                submittedValue = _context.sent;

                onChange(id, submittedValue);
                onBlur(id, submittedValue);
                this.handleModalClose();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleFormSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return handleFormSubmit;
    }()
  }, {
    key: 'handleAddNewClick',
    value: function handleAddNewClick() {
      this.setState({ showForm: true });
    }
  }, {
    key: 'handleModalClose',
    value: function handleModalClose() {
      this.setState({ formInput: {}, showForm: false });
      this.props.onModalClose();
    }
  }, {
    key: 'handleChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(selectedOption) {
        var value, _props2, id, onChange, onBlur;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (selectedOption) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                value = selectedOption.value;

                if (!(value === 'addNewOption')) {
                  _context2.next = 7;
                  break;
                }

                this.setState({ showForm: true });
                _context2.next = 11;
                break;

              case 7:
                _props2 = this.props, id = _props2.id, onChange = _props2.onChange, onBlur = _props2.onBlur;
                _context2.next = 10;
                return onChange(id, value);

              case 10:
                onBlur();

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleChange(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handleChange;
    }()
  }, {
    key: 'generateAddNewOption',
    value: function generateAddNewOption() {
      return {
        value: 'addNewOption',
        label: _react2.default.createElement(
          'button',
          { type: 'button', className: 'btn small', onClick: this.handleAddNewClick },
          this.props.addNewLabel
        )
      };
    }
  }, {
    key: 'updateOptions',
    value: function updateOptions(options) {
      return options.concat([this.generateAddNewOption()]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          id = _props3.id,
          value = _props3.value,
          placeholder = _props3.placeholder,
          fieldSuffix = _props3.fieldSuffix,
          valid = _props3.valid,
          options = _props3.options,
          clearable = _props3.clearable,
          formComponent = _props3.formComponent,
          formProps = _props3.formProps;


      var validClass = valid ? '' : 'invalid';

      var Form = formComponent;
      var modal = this.state.showForm ? _react2.default.createElement(
        _reactResponsiveModal2.default,
        {
          open: true,
          onClose: this.handleModalClose,
          classNames: { overlay: 'loading-overlay', modal: 'modal-wrapper status' },
          center: true
        },
        _react2.default.createElement(Form, _extends({
          onSubmit: this.handleFormSubmit,
          onChange: this.handleFormChange,
          formInput: this.state.formInput
        }, formProps))
      ) : null;

      var noResults = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          'No Results'
        ),
        this.generateAddNewOption().label
      );

      return _react2.default.createElement(
        'div',
        { className: 'select-input add-new-option' },
        modal,
        _react2.default.createElement(_reactSelect2.default, {
          id: id,
          value: value,
          placeholder: placeholder,
          className: validClass,
          onChange: this.handleChange,
          options: this.updateOptions(options),
          autoBlur: true,
          clearable: clearable,
          noResultsText: noResults
        }),
        fieldSuffix !== '' ? _react2.default.createElement(
          'span',
          { className: 'field-suffix' },
          fieldSuffix
        ) : null
      );
    }
  }]);

  return SelectInputAddNew;
}(_react2.default.PureComponent);

SelectInputAddNew.defaultProps = {
  value: '',
  placeholder: '',
  fieldSuffix: '',
  valid: true,
  options: [],
  clearable: false,
  onFormChange: _lodash.noop,
  onModalClose: _lodash.noop,
  formProps: {},
  addNewLabel: 'Add New'
};


SelectInputAddNew.propTypes = {
  id: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string,
  fieldSuffix: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  valid: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({})]).isRequired,
    className: _propTypes2.default.string
  })),
  clearable: _propTypes2.default.bool,
  formComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]).isRequired,
  onFormSubmit: _propTypes2.default.func.isRequired,
  onFormChange: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func,
  formProps: _propTypes2.default.shape({}),
  addNewLabel: _propTypes2.default.string
};

SelectInputAddNew.displayName = 'SelectInputAddNew';

exports.default = SelectInputAddNew;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/elements/SelectInputAddNew.js
// module id = 1207
// module chunks = 0